import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-terms-pdf',
  templateUrl: './termsPdf.component.html',
  styleUrls: ['./termsPdf.component.css']
})
export class TermsPdfComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }
}
